import {identity} from '@packages/utilities/fp/utils';
import {type Json, matchJson} from '@packages/utilities/json';

const migrateRef = matchJson({
  Null: identity,
  Boolean: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: number) => boolean | null'.
  Number: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: string) => boolean | null'.
  String: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: Json[]) => boolean | null'.
  Array: identity,
  // @ts-expect-error - TS2322 - Type '(refObj: { [key: string]: Json; }) => { [key: string]: Json; }' is not assignable to type '(arg1: { [key: string]: Json; }) => boolean | null'.
  Object: (refObj) => {
    const {id, path} = refObj;
    if (!id || !path || id !== 'overrides') return refObj;
    return {id: 'data', path};
  },
});

export const migrateOverridesToData: (arg1: Json) => Json = matchJson({
  Null: identity,
  Boolean: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: number) => boolean | null'.
  Number: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: string) => boolean | null'.
  String: identity,
  // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: Json[]) => boolean | null'.
  Array: identity,
  // @ts-expect-error - TS2322 - Type '(obj: { [key: string]: Json; }) => { [key: string]: Json; } | { type: string; ref: unknown; }' is not assignable to type '(arg1: { [key: string]: Json; }) => boolean | null'.
  Object: (obj) => {
    const {type, ref} = obj;
    if (!type || !ref || type !== 'Reference') return obj;
    const updatedRef = migrateRef(ref);
    return ref === updatedRef ? obj : {type, ref: updatedRef};
  },
});
